"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.NitrogenDeliveryRebalanced = void 0;
var PreludeCard_1 = require("../../prelude/PreludeCard");
var CardName_1 = require("../../../CardName");
var CardRenderer_1 = require("../../render/CardRenderer");
var Tags_1 = require("../../Tags");
var NitrogenDeliveryRebalanced = (function (_super) {
    __extends(NitrogenDeliveryRebalanced, _super);
    function NitrogenDeliveryRebalanced() {
        return _super.call(this, {
            name: CardName_1.CardName.NITROGEN_SHIPMENT_REBALANCED,
            tags: [Tags_1.Tags.EARTH],
            metadata: {
                cardNumber: 'P24',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.tr(2).plants(5).digit;
                }),
                description: 'Increase your TR 2 step. Gain 5 plant.',
            },
        }) || this;
    }
    NitrogenDeliveryRebalanced.prototype.play = function (player) {
        player.plants += 5;
        player.increaseTerraformRating();
        player.increaseTerraformRating();
        return undefined;
    };
    return NitrogenDeliveryRebalanced;
}(PreludeCard_1.PreludeCard));
exports.NitrogenDeliveryRebalanced = NitrogenDeliveryRebalanced;
//# sourceMappingURL=NitrogenDeliveryRebalanced.js.map